import types from "@/store/types/AclaracionComplementacionEnmienda";
import Vue from "vue";

const state = {
    datosAclaracionCompl: {},
    lstDatosAclaracionComplNet: [],
    lstTipoSolicitud:[],
    lstTipoSolicitudSeleccionado : []
};
const getters = {
    [types.getters.GetLstAclaracionComplNet]: state => {
        return state.lstDatosAclaracionComplNet;
    },
    [types.getters.GetAclaracionCompl]: state => {
        return state.datosAclaracionCompl;
    },
    [types.getters.GetTipoSolicitud]: state => {
        return state.lstTipoSolicitud;
    },
    [types.getters.GetTipoSolicitudSeleccionado ]: state => {
        return state.lstTipoSolicitudSeleccionado ;
    },
    
};
const mutations = {
    [types.mutations.SetLstAclaracionComplNet]: (state, lst) => {
        state.lstDatosAclaracionComplNet = lst;
    },
    [types.mutations.SetAclaracionCompl]: (state, obj) => {
        state.datosAclaracionCompl = obj;
    },
    [types.mutations.SetTipoSolicitud]: (state, lstTipoSolicitud) => {
        state.lstTipoSolicitud = lstTipoSolicitud;
    },
    [types.mutations.SetTipoSolicitudSeleccionado]: (state, lst) => {
        state.lstTipoSolicitudSeleccionado=lst;
    },
    [types.mutations.SetTipoSolicitudSeleccAlObtener]: (state, tipoSolicitudId) => {
        let lstAseleccionar = [];
        if(tipoSolicitudId==Vue.prototype.$const_dominio_id.ACLARACION_ID){
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.ACLARACION_ID);
    
        }
        if(tipoSolicitudId==Vue.prototype.$const_dominio_id.COMPLEMENTACION_ID){
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.COMPLEMENTACION_ID);
        
        }
        if(tipoSolicitudId==Vue.prototype.$const_dominio_id.ENMIENDA_ID){
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.ENMIENDA_ID);
       
        }
        if(tipoSolicitudId==Vue.prototype.$const_dominio_id.ACLARACION_COMPLEMENTACION_ENMIENDA_ID){
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.ACLARACION_ID);
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.COMPLEMENTACION_ID);
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.ENMIENDA_ID);

        }
        if(tipoSolicitudId==Vue.prototype.$const_dominio_id.ACLARACION_COMPLEMENTACION_ID){
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.ACLARACION_ID);
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.COMPLEMENTACION_ID);

        }
        if(tipoSolicitudId==Vue.prototype.$const_dominio_id.ACLARACION_ENMIENDA_ID){
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.ACLARACION_ID);
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.ENMIENDA_ID);
       
        }
        if(tipoSolicitudId==Vue.prototype.$const_dominio_id.COMPLEMENTACION_ENMIENDA_ID){
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.COMPLEMENTACION_ID);
          lstAseleccionar.push(Vue.prototype.$const_dominio_id.ENMIENDA_ID);
         
        }
        state.lstTipoSolicitudSeleccionado = lstAseleccionar;
    },
};
const actions = {
    [types.actions.RegistrarAclaracionComplementacionEnmienda]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.post(`pajel/aclaracion_complementacion_enmienda/add`, pObj).then(r => {
                resolve(r);
            });
        });
    },
    [types.actions.ActualizarAclaracionComplementacionEnmienda]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.put(`pajel/aclaracion_complementacion_enmienda/update/${pObj.aclaracionId}`, pObj).then(r => {
                resolve(r);
            });
        });
    },
    [types.actions.EnviarSolicitud]:({commit}, pObj) => {
        return new Promise ((resolve,reject)=>{
          Vue.prototype.$http.post(`pajel/aclaracion_complementacion_enmienda/net/enviar_solicitud`, pObj)
            .then(r => {
              resolve(r);
            });
        });
      },


    [types.actions.ObtenerAclaracionComplementacionByPromocionId]: ({ commit }, obj) => {
        return new Promise((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/aclaracion_complementacion_enmienda/obtenerAclaracionComplByPromocionPeId/${obj.promocionEmpresarialId}/${obj.estadoAclaracionId}`).then(r => {
                if(r.data.resultado){
                    commit(types.mutations.SetAclaracionCompl, r.data.resultado);
                    commit(types.mutations.SetTipoSolicitudSeleccAlObtener, r.data.resultado.tipoAclaracionId);
                }
                resolve(r);
            });
        })
    },
    [types.actions.ObtenerAclaracionComplementacionBySolicitudId]: ({ commit }, pSolicitudId) => {
        return new Promise((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/aclaracion_complementacion_enmienda/obtenerAclaracionComplBySolicitudId/${pSolicitudId}`).then(r => {
                
                if(r.data.resultado){
                    commit(types.mutations.SetTipoSolicitudSeleccAlObtener, r.data.resultado.tipoAclaracionId);
                    commit(types.mutations.SetAclaracionCompl, r.data.resultado);
                }
                resolve(r);
            });
        })
    },
    [types.actions.ObtenerTipoSolicitudByDominio]: ({ commit }, pDominio) => {
        return new Promise((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/aclaracion_complementacion_enmienda/obtenerTipoSolicitudByDominio/${pDominio}`).then(r => {
                commit(types.mutations.SetTipoSolicitud, r.data.resultado);
                resolve(r);
            });
        })
    },
    [types.actions.ObtenerAclaracionesNetPorPersonaId]: ({ commit }, pPersonaId) => {
        return new Promise((resolve,reject)=>{
            
            Vue.prototype.$http.get(`pajel/aclaracion_complementacion_enmienda/net/listPorPersonaId/${pPersonaId}`).then(r => {
                commit(types.mutations.SetLstAclaracionComplNet, r.data);
                resolve(r);
            });
        })
    }
};
export default {
    state,
    actions,
    getters,
    mutations
};
